import { jsxs as t, Fragment as p, jsx as r } from "react/jsx-runtime";
import { tv as c } from "tailwind-variants";
import n from "./Dropdown.js";
import b from "./Tab.js";
const f = c({
  slots: {
    dropdownWrapper: ["mobile:hidden"],
    tabsWrapper: [
      "border-b",
      "border-neutral-200",
      "hidden",
      "items-center",
      "mobile:inline-flex"
    ]
  }
}), { dropdownWrapper: v, tabsWrapper: h } = f(), j = ({
  activeTab: s,
  ariaLabel: d,
  dropdownClassName: o,
  onChange: l,
  options: a,
  tabsClassName: i
}) => /* @__PURE__ */ t(p, { children: [
  /* @__PURE__ */ r("div", { className: v({ class: o }), children: /* @__PURE__ */ r(
    n,
    {
      ariaLabel: d,
      onChange: l,
      options: a,
      value: s
    }
  ) }),
  /* @__PURE__ */ r("div", { className: h({ class: i }), children: a.map((e, m) => /* @__PURE__ */ r(
    b,
    {
      isActive: e.value === s,
      onClick: () => l(e.value),
      children: e.label
    },
    m
  )) })
] });
export {
  j as default
};
